import React from 'react';
import {userMedicinesDataLoader} from './userMedicinesDataLoader';

export const AllMedicineCategories = ({onProductCategoryClick, selectedProductCategory}) => {
    const medicinesData = userMedicinesDataLoader();

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                gap: '16px',
                padding: '2px',
                minWidth: '250px'
            }}
        >
            <h3 style={{margin: 0, textAlign: 'center'}}>Product Categories</h3>
            {[{category: {id: -1, name: 'All Products'}, medicines: []}, ...medicinesData].map(item => (
                <div
                    key={item.category.id}
                    style={{
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        padding: '4px 10px',
                        minWidth: '200px',
                        background: '#fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        textAlign: 'center',
                        cursor: 'pointer',
                        backgroundColor: selectedProductCategory?.id === item.category.id ? '#2a5298' : '#fff',
                        color: selectedProductCategory?.id === item.category.id ? '#fff' : '#000'
                    }}
                    onClick={() => onProductCategoryClick(item.category)}
                >
                    <span style={{margin: 0}}>
                        {item.category.name}
                    </span>
                </div>
            ))}
        </div>
    );
};

